import React, { forwardRef } from 'react'

import { InputBaseComponentProps } from '@mui/material'
import { IMaskInput } from 'react-imask'

const phoneMask = '(#00) 000-0000'

type PhoneNumberMaskedInputProps = InputBaseComponentProps & {
  name: string
  onChange: (event: { target: { name: string; value: string } }) => void
}

export const PhoneNumberMaskedInput = forwardRef<
  HTMLElement,
  PhoneNumberMaskedInputProps
>(function PhoneNumberMasked(props, ref) {
  const { onChange, ...rest } = props

  return (
    <IMaskInput
      {...rest}
      lazy={true}
      mask={phoneMask}
      definitions={{
        '#': /[1-9]/,
      }}
      onAccept={(value: string) => {
        const numericValue = value.replace(/\D/g, '');
        onChange?.({ target: { name: props.name, value: numericValue } });
      }}
      overwrite
      inputRef={ref}
    />
  )
})
